import '~style/index';
import Accordion from './libs/Accordion';
import '~libs/polyfill/requestIdleCallback';
// import scrollSlider from './libs/sliderScroll/index.js';

import * as svg4everybody from 'svg4everybody';
import Vue from 'vue';
import PortalVue from 'portal-vue';
Vue.use(PortalVue);
import store from './store';
import { TabsStroll } from './libs/TabsStroll';
import { importTinySlider } from './libs/util';
import LayoutGridHelper from 'layout-grid-helper';
import serviceRequest from './components/serviceRequest.vue';

const gridHelper = LayoutGridHelper({
	prefix: 'gh',
	sides: '16px',
	gutter: '16px',
	columns: 2,
	responsible: {
		320: {},
		640: {
			gutter: '20px',
			container: '620px',
			sides: '0px',
			columns: 4
		},
		960: {
			container: '940px',
			columns: 9
		},
		1600: {
			container: '1240px',
			columns: 10
		}
	}
});
gridHelper.init();

Vue.component('tabs-cities', () => import('./components/TabsCities.vue'));

Vue.component('factoring-calculator', () => import('./components/FactoringCalculator'));

Vue.component('service-request', () => import('./components/serviceRequest.vue'));

Vue.component(
	'form-factoring-calculator',
	() => import('./components/FactoringCalculator/FormFactoringCalculator.vue')
);

Vue.component('form-footer', () => import('./components/FormFooter.vue'));

Vue.component('bond-calculator', () => import(/* webpackChunkName: "investors" */ './components/BondCalculator.vue'));
Vue.component('accordion-bonds', () => import(/* webpackChunkName: "investors" */ './components/AccordionBonds'));
Vue.component(
	'news-subscription',
	() => import(/* webpackChunkName: "news-subscription" */ './components/NewsSubscription')
);

Vue.component(
	'open-exchange-account',
	() => import(/* webpackChunkName: "investors" */ './components/OpenExchangeAccount')
);
Vue.component(
	'leasing-calculator',
	() => import(/* webpackChunkName: "leasing-calculator" */ './components/LeasingCalculator')
);

import CitySelect from './components/CitySelect';
Vue.component('city-select', CitySelect);

// import CitySelectMobile from './components/CitySelectMobile';
// Vue.component('city-select-mobile', CitySelectMobile);

new Vue({ el: '#app', store });

if (document.querySelector('.leasing-children-tabs')) {
	new TabsStroll(document.querySelector<HTMLElement>('.leasing-children-tabs')!);
}
if (document.querySelector('.tender-help-step-tabs')) {
	new TabsStroll(document.querySelector<HTMLElement>('.tender-help-step-tabs')!);
}

import '~libs/sidebar';
Array.from<HTMLElement>(document.querySelectorAll('.accordion')).forEach((el) => new Accordion(el));

if (document.getElementById('section-contacts-toggle-content')) {
	document.getElementById('section-contacts-toggle-content')!.addEventListener('click', (event) => {
		event.preventDefault();
		const $target = event.target as HTMLButtonElement;
		const $rootSection = $target.closest('.section')!;
		const $content: HTMLElement | null = $rootSection.querySelector('.section-content');
		if (!$content) {
			return;
		}
		$rootSection.classList.toggle('open');
		if ($content.style.maxHeight) {
			$content.style.maxHeight = '';
		} else {
			$content.style.maxHeight = `${$content.scrollHeight}px`;
		}
	});
}

scrollToAnhor.onEnd(($element) => {
	const { anhor } = $element.dataset;
	if (anhor === 'contacts') {
		const $button = document.getElementById('section-contacts-toggle-content') as HTMLButtonElement;
		if (!$button) {
			return false;
		}
		const $rootSection = $button.closest('.section')!;
		if (Array.from($rootSection.classList).includes('open') === false) {
			$button.click();
		}
	}
});

if (document.querySelector('.partners-grid-slider')) {
	importTinySlider().then((tns) => {
		let slider = tns({
			container: '.partners-grid-slider > div',
			fixedWidth: 120,
			items: 10,
			mouseDrag: true,
			autoplayButton: false,
			autoplayButtonOutput: false,
			center: true,
			nav: false,
			controls: false
		});

		function hiddenPrevAndNextFilter() {
			const mediaQuery = window.matchMedia('(max-width: 1200px)');

			if (mediaQuery.matches) {
				const info = slider!.getInfo();
				const indexPrev = info.index - 1;
				const indexCurr = info.index;
				const indexNext = info.index + 1;

				info.slideItems[indexPrev].classList.remove('tns-slide-active');
				info.slideItems[indexCurr].classList.add('tns-slide-active');
				info.slideItems[indexNext].classList.remove('tns-slide-active');
			} else {
				let arrTnsSlideActive = Array.from(document.querySelectorAll('.tns-slide-active'));
				const arrTnsItems = Array.from(document.querySelectorAll('.partners-item.tns-item'));
				arrTnsItems.forEach((tnsItem) => {
					tnsItem.classList.remove('center-slide');
				});

				let average = Math.floor(arrTnsSlideActive.length / 2);

				arrTnsSlideActive[average].classList.add('center-slide');
			}
		}

		hiddenPrevAndNextFilter();

		slider.getInfo().slideItems[slider.getInfo().index].classList.add('tns-slide-active');

		slider.events.on('indexChanged', (event) => {
			hiddenPrevAndNextFilter();
		});
	});
}

// import { tns } from "./node_modules/tiny-slider/src/tiny-slider"

import { scrollToAnhor } from './libs/scrollToAnhor';
import { Branches, Branch } from './types';
import { NoEmitOnErrorsPlugin } from 'webpack';
if (document.querySelectorAll('.leasing-program-slider').length > 0) {
	// console.log(controls);
	importTinySlider().then((tns) => {
		tns({
			container: '.leasing-program-slider > div',
			items: 3,
			// slideBy: 'page',
			autoplayButton: false,
			autoplayButtonOutput: false,
			center: true,
			gutter: 30,
			nav: false,
			autoHeight: true,
			controls: false,
			controlsText: [
				'<svg width="45" height="83" viewBox="0 0 45 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.5 6L5 41.5L40.5 77" stroke-width="4"/></svg>',
				'<svg width="45" height="83" viewBox="0 0 45 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 6L40 41.5L4.5 77" stroke-width="4"/></svg>'
			],
			responsive: {
				500: {
					items: 3,
					fixedWidth: 395,
					autoplay: true
				},
				320: {
					items: 1,
					fixedWidth: 250,
					center: false,
					gutter: 20,
					autoplay: false
				}
			}
		});
	});
}
if (document.querySelectorAll('.main-slider').length > 0) {
	// console.log(controls);
	importTinySlider().then((tns) => {
		tns({
			// mode: 'gallery',
			container: '.main-slider > div',
			items: 1,
			// slideBy: 'page',
			// autoplay: true,
			autoplayButton: false,
			autoplayButtonOutput: false,
			center: true,
			gutter: 30,
			nav: false,
			autoHeight: true,
			controls: false,
			controlsText: [
				'<svg width="45" height="83" viewBox="0 0 45 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.5 6L5 41.5L40.5 77" stroke-width="4"/></svg>',
				'<svg width="45" height="83" viewBox="0 0 45 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 6L40 41.5L4.5 77" stroke-width="4"/></svg>'
			],
			responsive: {
				1600: {
					controls: true
				}
			}
			// controlsContainer: controls,
		});
	});
}

(function () {
	const mediaQuery = window.matchMedia('(max-width: 1200px)');
	if (document.querySelectorAll('.news-grid').length > 0 && mediaQuery.matches) {
		importTinySlider().then((tns) => {
			let slider = tns({
				container: '.news-grid',
				items: 3,
				autoplayButton: false,
				autoplayButtonOutput: false,
				center: true,
				gutter: 30,
				nav: false,
				autoHeight: true,
				controls: false,
				responsive: {
					500: {
						items: 3
					},
					320: {
						items: 1,
						center: false,
						fixedWidth: 240,
						gutter: 20,
						autoplay: false
					}
				}
			});
		});
	}
})();

(function () {
	const mediaQuery = window.matchMedia('(max-width: 768px)');
	if (document.querySelector('.partners-grid') && mediaQuery.matches) {
		importTinySlider().then((tns) => {
			let slider = tns({
				container: '.partners-grid',
				fixedWidth: 120,
				items: 11,
				autoplayButton: false,
				autoplayButtonOutput: false,
				center: true,
				nav: false,
				controls: false
			});

			function hiddenPrevAndNextFilter() {
				const info = slider!.getInfo();
				const indexPrev = info.index - 1;
				const indexCurr = info.index;
				const indexNext = info.index + 1;

				info.slideItems[indexPrev].classList.remove('tns-slide-active');
				info.slideItems[indexCurr].classList.add('tns-slide-active');
				info.slideItems[indexNext].classList.remove('tns-slide-active');
			}

			hiddenPrevAndNextFilter();

			slider.getInfo().slideItems[slider.getInfo().index].classList.add('tns-slide-active');

			slider.events.on('indexChanged', (event) => {
				hiddenPrevAndNextFilter();
			});
		});
	}
})();

(function () {
	const mediaQuery = window.matchMedia('(max-width: 768px)');

	if (mediaQuery.matches) {
		const topsAchievements = Array.from(document.querySelectorAll('.tops-achievements > div'));
		topsAchievements.forEach((div, index) => {
			if (index == 2) {
				let topPosition = Array.from(div.querySelectorAll('b'));
				topPosition.forEach((position) => (position.innerHTML += ' - '));
			}
		});
	}
})();

Array.from<HTMLAnchorElement>(document.querySelectorAll('.link-anhor')).forEach(($link) => {
	$link.addEventListener('click', (event: Event) => {
		const target: HTMLAnchorElement = event.target as HTMLAnchorElement;
		let { hash }: { hash: string } = target;
		hash = hash.replace(/^#/m, '') as string;
		const anhorElement: HTMLElement | null = document.querySelector(`[data-anhor="${hash}"`);
		if (anhorElement !== null) {
			scrollToAnhor(anhorElement);
			return false;
		}
	});
});

window.requestIdleCallback(() => {
	let { hash }: { hash: string } = new URL(window.location.toString());
	hash = hash.replace(/^#/m, '') as string;
	const anhorElement: HTMLElement | null = document.querySelector(`[data-anhor="${hash}"`);
	if (anhorElement !== null) {
		scrollToAnhor(anhorElement);
		return false;
	}
});
class BranchMap {
	private branches: Branches;
	private $container: HTMLElement;
	private interval: any;
	constructor() {
		this.branches = window.branches;
		this.$container = document.getElementById('branch-map')!;
		this.init();
		this.resizing();
		this.interval = setInterval(() => {
			const branches = Object.keys(this.branches);
			const city = branches[Math.floor(Math.random() * branches.length)];
			const target = document.getElementById(city) as HTMLElement;
			this.showToltip(target, this.branches[city]);
		}, 2000);
	}

	private init() {
		const clickHandle = this.clickHandle.bind(this);
		Array.from<HTMLElement>(this.$container.querySelectorAll('.city-name')).forEach(($el) => {
			$el.addEventListener('mouseover', clickHandle);
		});
	}
	private clickHandle(event: Event) {
		event.preventDefault();
		clearInterval(this.interval);
		if (event.target) {
			const target: HTMLElement = event.target as HTMLElement;
			const city = target.id;
			this.showToltip(target, this.branches[city]);
		}
	}

	private showToltip(target: HTMLElement, branch: Branch) {
		const toltip: HTMLElement = this.$container.querySelector('.branch-tooltip')! as HTMLElement;
		// toltip.style.display = 'close';
		toltip.classList.toggle('show', false);
		const template = this.templateToltip(branch);
		toltip.innerHTML = '';
		toltip.appendChild(template);
		const targetClientRect = target.getBoundingClientRect();
		const containerClientRect = this.$container.getBoundingClientRect();
		const left =
			targetClientRect.left +
			window.scrollX -
			containerClientRect.left -
			window.scrollX -
			toltip.getBoundingClientRect().width / 2 +
			targetClientRect.width / 2;
		const top =
			targetClientRect.top +
			window.scrollY -
			containerClientRect.top -
			window.scrollY -
			toltip.getBoundingClientRect().height -
			+targetClientRect.height;
		toltip.style.left = left + 'px';
		toltip.style.top = top + 'px';

		// toltip.style.display = 'block';
		toltip.classList.toggle('show', true);

		// console.log(left, top);
	}

	private templateToltip(branch: Branch) {
		const $content = document.createElement('div');
		const $title = document.createElement('h4');
		$title.innerText = branch.title;
		let text = '';
		if (branch.address) {
			text += `${branch.address}<br>`;
		}

		if (branch.phoneStationary) {
			text += `${branch.phoneStationary}<br>`;
			if (branch.addNumber) {
				text += `вн. ${branch.addNumber}<br>`;
			}
		}

		$content.appendChild($title);
		if (text.trim().length > 0) {
			const p = document.createElement('p');
			p.innerHTML = text;
			$content.appendChild(p);
		}
		return $content;
	}
	private resizing() {
		const mediaQuery = window.matchMedia('(max-width: 768px)');
		// const branchMapMobile: Array<Element> | null = Array.from(
		// 	document.querySelectorAll('.section-branch-map-mobile')
		// );
		const branchMapMobile = document.querySelector('.section-branch-map-mobile');
		if (mediaQuery.matches) {
			this.$container.style.display = 'none';
			branchMapMobile!.classList.add('show');
		}
	}
}

if (document.getElementById('branch-map')) {
	new BranchMap();
}

(function () {
	document.querySelector('.template-news-single-page .header')?.classList.add('header--scroll');
})();

window.addEventListener('scroll', () => {
	// let headerMobile = document.getElementById('header-mobile');
	document.getElementById('header')!.classList.toggle('header--scroll', window.scrollY > 40);
	document.querySelector('.city-select-wrapper')!.classList.toggle('scroll', window.scrollY > 40);
	// headerMobile!.classList.toggle('header--scroll', window.scrollY > 40);
});

svg4everybody();

Array.from<HTMLElement>(document.querySelectorAll('[data-spoiler-to]')).forEach(($el) => {
	$el.addEventListener('click', (event) => {
		event.preventDefault();
		const $target = event.target as HTMLElement;
		const { spoilerTo } = $target.dataset;
		const $from: HTMLElement | null = document.querySelector(`[data-spoiler-from="${spoilerTo}"]`);
		$target.classList.toggle('open');
		if ($from) {
			if ($from.style.maxHeight) {
				$from.style.maxHeight = '';
			} else {
				$from.style.maxHeight = `${$from.scrollHeight + 0}px`;
			}
		}
	});
});

function hideDesktopElemShowMobileElem(desktopElem: string, mobileElem: string) {
	const mediaQueryMobile = window.matchMedia('(max-width: 1200px)');
	const mediaQueryTablet = window.matchMedia('(min-width: 1200px)');
	const elemsDesktop = Array.from(document.querySelectorAll(desktopElem));
	const elemsMobile = Array.from(document.querySelectorAll(mobileElem));

	if (mediaQueryMobile.matches) {
		elemsDesktop.forEach((elem) => elem.classList.add('hide'));
		elemsMobile.forEach((elem) => elem.classList.add('show'));
	}

	if (mediaQueryTablet.matches) {
		elemsMobile.forEach((elem) => elem.classList.add('hide'));
	}
}

hideDesktopElemShowMobileElem('.leasing-children-tabs__icon-desktop', '.leasing-children-tabs__icon-mobile');

hideDesktopElemShowMobileElem('.round-outline-icon-desktop', '.round-outline-icon-mobile');
hideDesktopElemShowMobileElem('.button-send-and-advantages-text-desktop', '.button-send-and-advantages-text-mobile');

const footerState = document.querySelector('.footer-navigation__state .link-anhor');

footerState!.innerHTML = window.branches[window.branch].title;

function setMarginLeftToMainTitleInStaffPage() {
	let pageAboutTeam = document.querySelector('body.template-staff-page');

	if (pageAboutTeam) {
		let title = document.querySelector('body.template-staff-page .section-title__image')!;
		let container = document.querySelector('body.template-staff-page .page .container')!;
		let marginLeftContainerElem = window.getComputedStyle(container, null).getPropertyValue('margin-left');

		title.style.marginLeft = marginLeftContainerElem;
	}
}
setMarginLeftToMainTitleInStaffPage();
window.addEventListener('resize', setMarginLeftToMainTitleInStaffPage);
